import React from 'react';
import { Link } from 'react-router';
import {I18n} from 'react-redux-i18n';

const NotFoundPage = () => {
  return (
    <div>
      <h4>
        {I18n.t('PAGE_NOT_FOUND')}
      </h4>
      <Link to="/"> {I18n.t('GO_BACK_TO_HOMEPAGE')} </Link>
    </div>
  );
};

export default NotFoundPage;



/** WEBPACK FOOTER **
 ** ./src/modules/app/components/NotFoundPage.js
 **/